export const matchContact = [
  "/contact",
  "/contact/",
  "contact",
  "en/contact",
  "/en/contact",
  "en/contact/",
  "/en/contact/",
];
